import { Layout } from 'antd';

import { HeaderLeft } from '@/widgets/header/HeaderLeft/HeaderLeft';
import { HeaderRight } from '@/widgets/header/HeaderRight/HeaderRight';

import styles from './Header.module.css';

const { Header: AntHeader } = Layout;

type HeaderProps = {
  colorBgContainer: string;
  collapsed?: boolean;
  onToggleSidebar?: () => void;
  searchBar?: React.ReactNode;
};

export const Header: React.FC<HeaderProps> = ({ colorBgContainer, collapsed = false, onToggleSidebar, searchBar }) => {
  return (
    <AntHeader className={styles.header} style={{ background: colorBgContainer }}>
      <HeaderLeft collapsed={collapsed} onToggleSidebar={onToggleSidebar} />
      {searchBar}
      <HeaderRight />
    </AntHeader>
  );
};
